<template>
  <div class="toastification">
    <div class="d-flex align-items-start">
      <b-avatar :variant="variant" size="1.8rem" class="mr-75 flex-shrink-0">
        <feather-icon :icon="icon" size="15" />
      </b-avatar>
      <div class="d-flex flex-grow-1">
        <div>
          <h5
            v-if="title"
            class="mb-0 font-weight-bolder toastification-title"
            :class="`text-${variant}`"
            v-text="title"
          />
          <small v-if="text" class="d-inline-block text-body" v-text="text" />
        </div>
        <span
          class="cursor-pointer toastification-close-icon ml-auto"
          @click="$emit('close-toast')"
        >
          <feather-icon v-if="!hideClose" icon="XIcon" class="text-body" />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { BAvatar } from 'bootstrap-vue';

const ToastificationContent = {
  components: {
    BAvatar,
  },
  props: {
    variant: {
      type: String,
      default: 'primary',
    },
    icon: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      default: null,
    },
    hideClose: {
      type: Boolean,
      default: false,
    },
  },
};

export default ToastificationContent;

/**
 * HoC para reutilizacao de mensageria
 * @param {this.$toast} toast Referencia ao ToastPlugin
 * @param {*} timeout Configuracoes de timeout
 */
export function message(
  toast,
  timeout = { position: 'top-right', timeout: 8000 }
) {
  // Wrapper function para criar o estilo da mensagem
  const build = (icon, variant, title) => {
    return {
      component: ToastificationContent,
      props: {
        title: title,
        icon: icon,
        variant: variant,
      },
    };
  };

  return {
    error: function (title) {
      toast(build('BellIcon', 'danger', title), timeout);
    },
    success: function (title) {
      toast(build('CheckIcon', 'success', title), timeout);
    },
    warning: function (title) {
      toast(build('AlertTriangleIcon', 'warning', title), timeout);
    },
    info: function (title) {
      toast(build('AlertTriangleIcon', 'info', title), timeout);
    },
  };
}
</script>

<style lang="scss" scoped>
.toastification-close-icon,
.toastification-title {
  line-height: 26px;
}

.toastification-title {
  color: inherit;
}
</style>
